import React from "react"
import { Link } from "wouter"
import { AxiosError } from 'axios';
import { singupFields, singup as singupAPI } from "../services/api"
import { XCircleIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline"



export const requiredFieldsByType = {
  'PF': [
    'cf',
  ],
  'A': [
    'piva',
    'business_name',
    'pec',
    'receiver_code',
  ]
};

export const formatField = (field, name, id, ref, passwordVisibility, togglePasswordVisibility, value) => {
  const refFunction = (el) => {
    if(el && value)
      el.value = value;
    ref.current[name] = el;
  };

  if(Array.isArray(field.type)) {
    const attrs = {};

    return <select name={id} id={id} {...attrs} required={field.required} ref={refFunction}>
      {
        field.type.map(choice => (
          <option key={choice[0]} value={choice[0]}>{choice[1]}</option>
        ))
      }
    </select>;
  }

  if (['password1', 'password2'].includes(name)) {
    const isPasswordVisible = passwordVisibility[name] || false;

    return (
      <div className="relative">
        <input
          id={id}
          name={id}
          type={isPasswordVisible ? 'text' : 'password'}
          required={field.required}
          ref={refFunction}
          className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
        <div
          className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
          onClick={() => togglePasswordVisibility(name)}
        >
          {isPasswordVisible ? (
            <EyeSlashIcon className="h-5 w-5 text-gray-500" />
          ) : (
            <EyeIcon className="h-5 w-5 text-gray-500" />
          )}
        </div>
      </div>
    );
  }

  switch (field.type) {
    case 'bool':
      return <input
          id={id}
          name={id}
          type='checkbox'
          value='true'
          required={field.required}
          className=""
          ref={refFunction}
        />

    default:
      return <input
          id={id}
          name={id}
          type={field.type}
          required={field.required}
          ref={refFunction}
          className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
  }
}

export default function Signup() {
  const dataRef = React.useRef({});
  // const [data, setData] = React.useState({email: 'giova.panasiti@gmail.coma', codice: '3', password: 'panasiti'})
  const [error, setError] = React.useState(null);
  const [fields, setFields] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [passwordVisibility, setPasswordVisibility] = React.useState({});

  const togglePasswordVisibility = (fieldName) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [fieldName]: !prev[fieldName],
    }));
  };

  const signup = (e) => {
    e.preventDefault();
    setError(null);
      
    setLoading(true);
    const data = Object.fromEntries(
      Object.keys(dataRef.current).map(key => {
        return [key, dataRef.current[key]?.value]
      })
    );

    singupAPI(data)
      .then(response => setSuccess(response.success))
      .catch(e => {
        const error = e;

        if(error.response?.data?.error) {
          const errors = error.response.data.error;
          setError(errors);
          return false;
        }

        throw new Error(`Error in 'singup': ${error.message}`);
      });

      setLoading(false);
    return false;
  }

  React.useEffect(() => {
    const getFields = async () => {
      setLoading(true);
      const fieldsData = await singupFields();
      setFields(fieldsData);
      setLoading(false);
      handleTypology('PF');
    };

    getFields();
  }, []);


  const handleTypology = (type) => {
    const requiredFields = requiredFieldsByType[type];

    const fieldsToHide = requiredFieldsByType[type === 'PF' ? 'A' : 'PF'];

    setFields((prev) => {
      const fieldsNew = {};

      Object.keys(prev).map(field_name => {
        fieldsNew[field_name] = prev[field_name];

        //VEDERE RIGA 122 -> DA SOSTITUIRE CON 125?
        // fieldsNew[field_name] = { ...prev[field_name] };

        if(fieldsToHide.includes(field_name)) {
          fieldsNew[field_name]['required'] = false;
          fieldsNew[field_name]['hide'] = true;
          return;
        }

        if(requiredFields.includes(field_name)) {
          fieldsNew[field_name]['required'] = true;
          fieldsNew[field_name]['hide'] = false;
          return;
        }

      });

      return fieldsNew;
    });
  };

  const urls = {
    'check1': 'https://consultala.com/termini/',
    'check2': 'https://consultala.com/privacy/',
  }

  // const refFunction = (el: HTMLSelectElement | HTMLInputElement | null) => {
  //   dataRef.current[name] = el;
  // };

  

  return (
    <>
      <div
        className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8"
        id="main_bg"
        style={{
          minHeight: '100vh',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-white">Registrazione</h2>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <XCircleIcon className="h-5 w-5 text-red-400" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">
                    Si è verificato un errore
                  </h3>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
            {
              success ? 
              <>
                <h4>Sono state inviate sulla tua email le credenziali di accesso</h4>   
                <div className="text-sm mt-5">
                    <Link
                      to="/"
                      className="font-medium text-indigo-600 hover:text-indigo-500">
                      Torna al login
                    </Link>
                </div> 
              </>
              : <>
                {!loading && (
                  <form className="space-y-6" onSubmit={(e) => false}>
                    {
                      Object.keys(fields)
                        .sort((a, b) => {
                          if(['check1', 'check2'].includes(a))
                            return 1;

                          if(['check1', 'check2'].includes(b))
                            return -1;

                          return 0;
                        })
                        .map((name, idx) => {
                        const field = fields[name];
                        const id = `${name}_${idx}`;
                        let field_formatted = formatField(field, name, id, dataRef, passwordVisibility, togglePasswordVisibility)
                        if (name == 'typology') {
                          field_formatted = <select ref={(el) => {dataRef.current[name] = el;}} {...field_formatted.props} 
                          onChange={(e) => handleTypology(e.target.value)} 
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          />
                        }

                        if (name === 'country') {
                          const countryOptions = fields.country?.type?.map(([value, label]) => ({
                            value,
                            label,
                          }));
                        
                          field_formatted = (
                            <select
                              ref={(el) => { dataRef.current[name] = el; }}
                              {...field_formatted.props}
                              defaultValue="Italia"
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            >
                              {countryOptions?.length > 0 && (
                                countryOptions.map((option, idx) => (
                                  <option key={idx} value={option.value}>
                                    {option.label}
                                  </option>
                                ))
                              )}
                            </select>
                          );
                        }                      

                        return <div key={id} style={{display: (field.hide ? 'none' : 'block') }}>
                          <label htmlFor={id} className="block text-sm font-medium leading-6 text-gray-900">
                            {
                              urls[name]
                              ? <a href={urls[name]} target="_blank" className="underline">{field.label}</a>
                              : field.label
                            } {field.required && '*'}
                            { 
                              error && error[name] 
                              && <div className="mt-2 text-sm text-red-700">
                                <ul role="list" className="list-disc space-y-1 pl-5">
                                  {
                                    error[name].map((e, idx) => (
                                      <li key={idx}>{e}</li>
                                    ))
                                  }
                                </ul>
                              </div>
                            }
                          </label>
                          <div className="mt-2">
                            { field_formatted }
                          </div>
                        </div>
                      
                      })
                    }

                    <div className="text-sm">
                      <Link
                        to="/login"
                        className="font-medium text-indigo-600 hover:text-indigo-500">
                        Hai già un account? Accedi
                      </Link>
                    </div>

                    <div>
                      
                    </div>
                  </form>
                  
                  )}
                  <button
                        type="button"
                        onClick={signup}
                        className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      >
                        Registrati
                      </button>

                  {loading && (
                    <div className="text-center">
                    <div role="status">
                      <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                    </div>
                  )}
              </>
            }  
          </div>
        </div>
      </div>
    </>
  )
}
